import axios from 'axios';
// import { Message } from 'element-ui';
import { getToken } from '@/utils/auth';

export const baseURL = window.API_URL || process.env.API_URL;
// create an axios instance
const service = axios.create({
  baseURL,
  timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  async config => {
    // Do something before request is sent
    const store = (await import('@/store/index.ts')).default; // store must be loaded lazy to that no circular import occurs
    if (store.getters.token) {
      // Let each request carry token
      config.headers['Authorization'] = 'Bearer ' + getToken();
    }
    if (store.getters.language) {
      config.headers['Accept-Language'] = store.getters.language;
    }
    if (store.getters['domain/getCurrentDomainID'] && (!config.params || !config.params.forceAllDomains)) {
      config.headers['Current-DomainID'] = store.getters['domain/getCurrentDomainID'];
    } else {
      if (config.params) {
        delete config.params.forceAllDomains;
      }
      config.headers['Current-DomainID'] = store.state.domain.ALL_DOMAINS;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => response,
  async error => {
    const store = (await import('@/store/index.ts')).default;
    store.dispatch('notify/requestError', error);
    return Promise.reject(error);
  }
);

export default service;
